import React from 'react';
import IconSuccess from '../../images/icon-success.png';
import IconFailure from '../../images/icon-failure.png';

const PaymentHistoryTab = ({ paymentHistory = [] }) => {
    return (
        <>
            <h3 className="mb-3 fw-bold" style={{ fontSize: '20px' }}>Payment History</h3>

            {paymentHistory.length > 0 ? (
                <div className="border">
                    {paymentHistory.map((transaction, index) => (
                        <div
                            key={transaction.id || index}
                            className="d-flex align-items-center border-bottom p-3 payment-history"
                        >
                            <div className="d-flex align-items-center me-2">
                                {transaction.status === 'success' ? (
                                    <img src={IconSuccess} alt="success" className='me-3 my-auto' width={35} height={35} />
                                ) : (
                                    <img src={IconFailure} alt="failed" className='me-2 my-auto' width={35} height={35} />
                                )}
                            </div>

                            <div className="flex-grow-1">
                                <p className="fw-bold text-primary mb-0">{"Professional Plan – Monthly"}</p>
                                <div className="text-light small">
                                    {transaction.cardType === 'visa' && 'Visa'}
                                    {transaction.cardType === 'mastercard' && 'Mastercard'}
                                    {transaction.cardType === 'amex' && 'American Express'}
                                    {transaction.cardType && ` ending in ${transaction.last4}`} • {transaction.date}
                                </div>
                                <div className="text-muted small">Trans.ID: {transaction.id}</div>
                            </div>

                            <div className="text-end me-5">
                                <p className="fw-bold mb-0 text-primary">${transaction.amount?.toFixed(2)}</p>
                                <div className={transaction.status === 'success' ? 'text-success' : 'text-danger'}>
                                    {transaction.status === 'success' ? 'Success' : 'Failed'}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <p className="text-center text-light" style={{ fontSize: '14px' }}>
                    No payment history available.
                </p>
            )}
        </>
    );
};

export default PaymentHistoryTab;